import styles from './availableProperties.module.css';
import globalStyles from '../result.module.css';
import AreaContainer from "../AreaContainer";
import { useRef, useState } from "react";
import Link from "next/link";
import LazyImage from "components/LazyImage";
import TablePagination from '@mui/material/TablePagination';

type PropertyRowProps = {
    id: number,
    url_fragment: string,
    scheme_uri: string,
    url: string | undefined,
    name: string,
    size_ft_max: string | undefined,
    rent_pa: string | undefined, address: string | undefined,
    availability: string[],
    thumbnail: image | undefined,
    full_name: string
}

type image = {
    title: string,
    name: string,
    format: {
        w400wp: {
            uri: string
        }
    }
}

const PropertyRow = ({
  id,
  url_fragment,
  scheme_uri,
  url,
  name,
  size_ft_max,
  rent_pa,
  address,
  availability,
  thumbnail,
  full_name
}: PropertyRowProps) => {
  const thumbnail_uri = thumbnail?.format?.w400wp?.uri
    ? `${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${thumbnail.format.w400wp.uri}`
    : 'https://neo.completelyretail.co.uk/fallback-images/sc-fullback.jpeg'
  const propertyLinkRef = useRef<HTMLAnchorElement>(null);
  let propertyUri = url_fragment || id;
  const href = `/scheme/${scheme_uri}/property/${propertyUri}`;
  return (
    <li
      key={`avi-${id}`}
      className={thumbnail_uri ? styles.childContainer : `${styles.childContainer} ${styles.childContainerNoImage}`}
      onClick={
        (e) => {
          if ((e.target as HTMLElement).tagName !== "BUTTON" && (e.target as HTMLElement).tagName !== "A") {
            propertyLinkRef.current?.click();
          }
        }
      }
    >
      {thumbnail_uri && (
        <div className={`${styles.childImage} ${styles.thumbNail}`}>
            <LazyImage
                src={`${thumbnail_uri}`}
                layout="fill"
                objectFit="cover"
                alt={name || full_name}
            />
        </div>
      )}
      <a
        className={`${styles.cardHeading} ${styles.ChildCardHeading}`}
        href={`${url || href}`}
        ref={propertyLinkRef}
        aria-label={`View ${name} on Completely Retail`}
        onClick={(e) => { }}
      >
      <h2 itemScope itemType="https://schema.org/Place">
        <address title={`${name} ${address || ''}`} itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
        <meta itemProp="streetAddress" content={`${name} ${address}`} />
        <meta itemProp="addressCounty" content="GB" />
        <span>{name || full_name} </span>
        </address>
      </h2>
      </a>
      <div className={`${styles.statsTray}`}>
        <div className={styles.statsTrayChild}>
          {availability && (
              <div className={styles.tagTitle}>Availability: <span>{availability.join(' / ')}</span></div>
          )}
          {size_ft_max && (
              <div className={styles.tagTitle}>Size: <span>{size_ft_max ? parseInt(size_ft_max).toLocaleString() : "--"} ft²</span></div>

          )}
          {rent_pa && (
              <div className={styles.tagTitle}>Rent: <span>{rent_pa ? `£${parseInt(rent_pa).toLocaleString()}` : "POA"}</span></div>
          )}
        </div>
        <Link href={`/scheme/${scheme_uri}/property/${url_fragment}`} passHref prefetch={false} >
          <button className={styles.primaryButton}>View details</button>
        </Link>
      </div>
    </li>
  );
};

type Props = {
    properties: [],
    portfolio: {
        styles: {
            main: string
        }
    },
    scheme_uri: string
}

const AvailableProperties = ({ properties, portfolio, scheme_uri }: Props) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <AreaContainer area={'availability'} style={null} extraClass={undefined}>
            <div className={styles.AvailibilityWrapper}>
                <h2 className={globalStyles.subTitleText}>Availability</h2>
                <div className={styles.insideContainer} style={{ background: portfolio?.styles?.main ? portfolio.styles.main : '#F2F2F2' }}>
                    <ul>
                        {(rowsPerPage > 0
                            ? properties.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : properties
                        ).map(
                          (property: PropertyRowProps) =>
                            <PropertyRow
                              key={`avi-${property.id}`}
                              {...property}
                              name={property.full_name}
                              scheme_uri={scheme_uri}
                            />
                        )}
                    </ul>
                    {properties.length > 10 && (
                        <TablePagination
                            rowsPerPageOptions={[10]}
                            component="div"
                            count={properties.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            className={styles.pagination}
                        />
                    )}

                </div>
            </div>
        </AreaContainer>
    )
}

export default AvailableProperties;